import React, { Fragment, useEffect, useState } from 'react'
import { GetCookieToken } from '../../Cookie/GetCookie';
import axios from 'axios';
import { Badge, Button, Col, Collapse, FormFeedback, FormGroup, Input, Label, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import LoadingData from '../../TESTPage/LoadingData';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { FetchAxiosDelte, FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from '../../../api/axios';
import Select from 'react-select';
import ConfirmModal from '../../../components/Common/ConfirmModal';
// import styles from "../../assets/css/OPDCNews.module.css";

const API_URL = process.env.REACT_APP_API_CORS;

function OrganizationChart() {
    let arrayReplace = []
    const [data, setData] = useState([]);
    const [userOrg, setUserOrg] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(false);
    const [checkActive, setCheckActive] = useState(false);
    const [modalAddOrEdit, setModalAddOrEdit] = useState(false);
    const token = GetCookieToken("userToken");
    const [modalState, setModalState] = useState("");
    const [confirmModal, setConfirmModal] = useState(false);
    const [confirmModalState, setConfirmModalState] = useState("");
    const [orgOptions, setOrgOptions] = useState([]);
    const [dataInput, setDataInput] = useState({
        org_name: null,
        short_name: null,
        active: 0,
        nodelv: null,
        parent_id: null,
        parent_key: null
    });
    const org_structure = [
      {
        feild: [
          {
            key: "nodelv",
            option: (nodelv) =>{
              return parseInt(nodelv) + 1
            }
          },
          {
            key: "parent_id",
            option: (parent_id) =>{
              return parent_id
            }
          },
          {
            key: "parent_key",
            option: (parent_key) =>{
              return parent_key
            }
          },
        ],
        label: "อยู่ภายใต้ สำนัก/กอง/กลุ่ม",
        org_chart: true,
        validated: true,
        checkbox: false,
      },
      {
        label: "ชื่อองค์กร",
        feild: "org_name",
        invalidFeedback: "โปรดกรอกชื่อองค์กร",
        invalidCheck: true,
        type: "text",
        org_chart: false, 
        checkbox: false,
        validated: false
      },
      {
        label: "ชื่อย่อ องค์กร",
        feild: "short_name",
        invalidFeedback: "",
        invalidCheck: false,
        type: "text",
        org_chart: false,
        checkbox: false,
        validated: false
      },
      {
        label: "ใช้งาน",
        feild: "active",
        invalidFeedback: "",
        invalidCheck: true,
        type: "checkbox",
        checkbox: true,
        org_chart: false,
        validated: false
      },
    ]

    const fetchData = async () => {
        setLoading(true);
        const url = `${API_URL}/api/orgInner/level`;
        const config = {headers: {Authorization: `Bearer ${token}`}};
        await axios.get(url, config).then(response => {
          
          let dataOrg = response.data.result
          setData(dataOrg); 
          fetchUserFromOrg(dataOrg.org_id, dataOrg.nodelv)

          let options = [{ 
                  value: dataOrg.org_id, 
                  label: dataOrg.org_name, 
                  parent_id: dataOrg.parent_id,
                  parent_key: dataOrg.parent_key, 
                  nodelv: dataOrg.nodelv, 
                  short_name: dataOrg.short_name,
                  active: dataOrg.active 
              }];
          if (dataOrg?.child.length > 0) {
              dataOrg?.child.forEach(element => {
                  fetchUserFromOrg(element.org_id, element.nodelv)
                  options.push({ 
                      value: element.org_id, 
                      label: element.org_name, 
                      parent_id: element.parent_id, 
                      parent_key: element.parent_key, 
                      nodelv: element.nodelv, 
                      short_name: element.short_name,
                      active: element.active
                  })
              });
              if (dataOrg?.child.filter(x => x.child.length > 0).length > 0 ) {
                dataOrg?.child?.filter(x => x.child.length > 0).forEach(element => {
                  element?.child.forEach(elementChild => {
                      fetchUserFromOrg(elementChild.org_id, elementChild.nodelv)
                      options.push({ 
                          value: elementChild.org_id, 
                          label: elementChild.org_name, 
                          parent_id: elementChild.parent_id, 
                          parent_key: elementChild.parent_key, 
                          nodelv: elementChild.nodelv, 
                          short_name: elementChild.short_name,
                          active: elementChild.active 
                      })
                  });
                });
              }
          }
          setOrgOptions(options)
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        }).catch(error => console.error("Error:", error));
      };

    const toggle = () => {
      setModal(!modal);
      setData([]);
      setUserOrg([]);
      setModalAddOrEdit(false);
      setCheckActive(false)
      setModalState("");
      setConfirmModal(false);
      setConfirmModalState("");
      setOrgOptions([]);
      setDataInput({
          org_name: null,
          short_name: null,
          active: 0,
          nodelv: null,
          parent_id: null,
          parent_key: null
      });
    };

    const fetchUserFromOrg = async (org_id,nodeLv) =>{
        const url = "/api/users/position/datatable";
        let params = new URLSearchParams({
            page: 1,
            size: 10,
            "order[0]": "id",
            "order[1]": "DESC",
            "filter[assign][0]": "0",
            "filter[org_id][0]": org_id,
            "filter[status][0]": 1,
          });
        if (nodeLv === 1) {
            params.append("filter[position_id][0]", 2)
        } else if (nodeLv === 2) {
            params.append("filter[position_id][0]", 5)
            params.append("filter[position_id][1]", 4)
            // params.append("filter[position_id][2]", 3)
        } else if (nodeLv === 3) {
            params.append("filter[position_id][0]", 7)
        }
        const response = await FetchAxiosGet(url,token,params)
        if (response?.result[0] !== undefined) {
          arrayReplace.push({user_name: response.result[0]?.user_name, org_id: response.result[0]?.org_id, position_id: response.result[0]?.position_id})
          setUserOrg(arrayReplace)
        }
    }

    useEffect(() => {
      if (modal === true) {
        
        fetchData();

      }
    }, [modal])

    const toggles = (delte = null) =>{
      if (delte !== null) {
          setModalAddOrEdit(false)
      } else {
          setModalAddOrEdit(!modalAddOrEdit)
      }
      setModalState("")
      setDataInput({
        org_name: null,
        short_name: null,
        active: 0,
        nodelv: null,
        parent_id: null,
        parent_key: null
      })
  }

  const fetchToDB = async () => {
    if (modalState === "ADD") {
        const intoDB = await FetchAxiosPost('/api/orgInner/save', dataInput, token)
    } else if (modalState === "EDIT") {
        const intoDB = await FetchAxiosPut(`/api/orgInner/${dataInput?.org_id}`, 
          {
            org_name: dataInput.org_name,
            short_name: dataInput.short_name,
            active: dataInput.active,
            nodelv: dataInput.nodelv,
            parent_id: dataInput.parent_id,
            parent_key: dataInput.parent_key,
          }, token)
    }
    toggles()
    setData([])
    setUserOrg([])
    await fetchData()
}

  const handleInputChange = async (event, field, validatedManyInput, types = null) => {
    if (validatedManyInput) {
      field.map(item =>{
        setDataInput(prevData => ({ ...prevData, [item.key]: item.option(event[item.key === "parent_id" ? "value" : item.key]) }));
      })
    } else {
      setDataInput(prevData => ({ ...prevData, [field]: types ? event.target.checked ? 1 : 0 : event.target.value }));
    }
  };

  const EditDataTable = async (id) =>{
      const editData = orgOptions.find(x => x.value === id)
      setDataInput({
          org_id: id,
          org_name: editData.label,
          short_name: editData.short_name,
          active: editData.active,
          nodelv: editData.nodelv,
          parent_id: editData.parent_id,
          parent_key: editData.parent_key,
      })
  }

  useEffect(() => {
    if (modalState === "ADD") {
      setDataInput(prevData =>({
          ...prevData,
          nodelv: parseInt(data.nodelv) + 1,
          parent_id: data.org_id,
          parent_key: data.parent_key
      }))
    }
  }, [modalState])

  const positionNoDeleteDataTable = async () =>{
      const response = await FetchAxiosDelte(`/api/orgInner/${dataInput?.position_no_id}`, token)
      toggles('delte')
      setLoading(true)
      fetchData()
      setTimeout(() => { setLoading(false) }, 1000);
  }

  return (
    <Fragment>
      <Button color="secondary" onClick={toggle} style={{whiteSpace: "nowrap"}}>
        <i className="fa-regular fa-users"></i> ผังองค์กร
      </Button>
      <Modal isOpen={modal} toggle={toggle} centered size="xl">
        <ModalHeader>
          ผังองค์กร
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggle}></i>
          </div>
        </ModalHeader>
        <ModalBody style={{ overflowX: "scroll"}}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "500px",
              }}
            >
              <LoadingData />
            </div>
          ) : (
            <FadeIn>
              <Row>
                <Col className='d-flex justify-content-start'>
                  <FormGroup className='d-flex align-items-center'>
                    <Label className="me-2 mb-0"> ดูผังองค์กรทั้งหมด : </Label>
                    <Input defaultChecked={checkActive} addon type='checkbox' onChange={() => setCheckActive(!checkActive)}/>
                  </FormGroup>
                </Col>
                <Col className='d-flex justify-content-end'>
                  <Button disabled={loading} className="mb-3" color="primary" onClick={() => {setModalAddOrEdit(true); setModalState("ADD")} }><i className="fa-solid fa-user-plus me-1"></i> เพิ่มข้อมูล </Button>
                </Col>
              </Row>
                <ListGroup style={{ minWidth:"1106px"}}>
                  <Fragment>
                    <ListGroupItem action className="py-0" onClick={() => {setModalAddOrEdit(true); setModalState("EDIT"); EditDataTable(data.org_id)}}>
                      <Row className="py-2" >
                        <Col xs={12} lg={12}>
                          <div
                            className="w-100 d-flex justify-content-between"
                            style={{
                              cursor: "pointer",
                              transition: "background-color 0.3s",
                            }}
                          >
                            <Col xl={9} md={9} xs={9}>
                              <span className='w-50'>
                                {data?.org_name} 
                                <Badge className='ms-2' color={data?.active == 1 ? "success" : "danger"}>{data?.active == 1 ? "ใช้งาน" : "ไม่ใช้งาน"}</Badge>
                              </span>
                            </Col>
                            <Col xl={3} md={3} xs={3} style={{marginLeft: "1.5rem"}}>
                                <span className='text-success'> {userOrg?.find(x => x.org_id === data.org_id)?.position_id === 2 && "เลขาธิการ : "} {userOrg?.find(x => x.org_id === data.org_id)?.user_name} </span>
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <Collapse isOpen={true}>
                      {data.child?.sort((a, b) => {
                          const nameA = a.org_name.toLowerCase();
                          const nameB = b.org_name.toLowerCase();
                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;
                          return 0;
                        }).map((org, index) => 
                           (checkActive || (org.active !== 0 && org.active !== undefined) )&&
                           org.child?.length < 1 &&
                           <ListGroupItem action className="py-0" onClick={() => {setModalAddOrEdit(true); setModalState("EDIT"); EditDataTable(org.org_id)}}>
                              <Row>
                                <Col xs={12} lg={12}>
                                  <div
                                  key={org.org_id}
                                  className="my-2 w-100 d-flex justify-content-between"
                                  style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                      marginLeft: "1.5rem",
                                  }}
                                  >
                                      <Col xl={9} md={9} xs={9}>
                                        <span className='w-50'>
                                          {org.org_name} 
                                          <Badge className='ms-2' color={org.active == 1 ? "success" : "danger"}>{org.active == 1 ? "ใช้งาน" : "ไม่ใช้งาน"}</Badge>
                                        </span>
                                      </Col>
                                      <Col xl={3} md={3} xs={3}>
                                        <span className='me-2 text-success'>
                                          {userOrg?.find(x => x.org_id === org.org_id)?.position_id === 3 
                                            ? "รองเลขาธิการ : "
                                            : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 4 
                                            ? "ผู้ช่วยเลขาธิการ : "
                                            : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 5 
                                            ? "ผู้อำนวยการกอง : "
                                            : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 6 
                                            ? "ผู้เชี่ยวชาญกอง : "
                                            : ""
                                          }
                                          {userOrg?.find(x => x.org_id === org.org_id)?.user_name}
                                        </span>
                                      </Col>
                                  </div>
                                </Col>
                              </Row>
                            </ListGroupItem> 
                        )}
                    </Collapse>
                    <Collapse isOpen={true}>
                          {data.child?.sort((a, b) => {
                              const nameA = a.org_name.toLowerCase();
                              const nameB = b.org_name.toLowerCase();
                              if (nameA < nameB) return -1;
                              if (nameA > nameB) return 1;
                              return 0;
                              }).map((org, index) =>
                              org.child.length !== 0 &&
                              ((org.active !== 0 && org.active !== undefined) || checkActive) ? 
                                  <Fragment>
                                      <ListGroupItem action className="py-0" onClick={() => {setModalAddOrEdit(true); setModalState("EDIT"); EditDataTable(org.org_id)}}>
                                      <Row className="py-2">
                                          <Col xs={12} lg={12}>
                                              <div
                                                  className="ms-3 w-100 d-flex justify-content-between"
                                                  key={org.org_id}
                                                  style={{
                                                      cursor: "pointer",
                                                      transition: "background-color 0.3s",
                                                      paddingLeft: "0.5rem",
                                                  }}
                                              >
                                                  <Col xl={9} md={9} xs={9}>
                                                    <span className='w-50'>
                                                      {org.org_name} 
                                                      <Badge className='ms-2' color={org.active == 1 ? "success" : "danger"}>{org.active == 1 ? "ใช้งาน" : "ไม่ใช้งาน"}</Badge>
                                                    </span>
                                                  </Col>
                                                  <Col xl={3} md={3} xs={3}>
                                                    <span className='text-success' style={{paddingLeft: "0.4rem"}}>
                                                      {/* ผู้อำนวยการ :  */}
                                                      {userOrg?.find(x => x.org_id === org.org_id)?.position_id === 3 
                                                        ? "รองเลขาธิการ : "
                                                        : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 4 
                                                        ? "ผู้ช่วยเลขาธิการ : "
                                                        : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 5 
                                                        ? "ผู้อำนวยการกอง : "
                                                        : userOrg?.find(x => x.org_id === org.org_id)?.position_id === 6 
                                                        ? "ผู้เชี่ยวชาญกอง : "
                                                        : ""
                                                      }
                                                      {userOrg?.find(x => x.org_id === org.org_id)?.user_name}
                                                    </span>
                                                  </Col>
                                              </div>
                                          </Col>
                                      </Row>
                                      </ListGroupItem>
                                      <Collapse isOpen={true}>
                                      {org.child.sort((a, b) => {
                                          const nameA = a.org_name.toLowerCase();
                                          const nameB = b.org_name.toLowerCase();
                                          if (nameA < nameB) return -1;
                                          if (nameA > nameB) return 1;
                                          return 0;
                                          }).map(i =>
                                         (i.active !== 0 || checkActive) &&
                                          i.active !== undefined ? 
                                              <ListGroupItem action className="py-0" onClick={() => {setModalAddOrEdit(true); setModalState("EDIT"); EditDataTable(i.org_id)}}>
                                                  <div
                                                      key={i.org_id}
                                                      className="py-2 w-100 d-flex justify-content-between"
                                                      style={{
                                                          cursor: "pointer",
                                                          transition: "background-color 0.3s",
                                                          marginLeft: "3.5rem",
                                                      }}
                                                  >
                                                      <Col xl={8} md={8} xs={8}>
                                                        <span className='w-50'>
                                                          {i.org_name} 
                                                          <Badge className='ms-2' color={i.active == 1 ? "success" : "danger"}>{i.active == 1 ? "ใช้งาน" : "ไม่ใช้งาน"}</Badge>
                                                        </span>
                                                      </Col>
                                                      <Col xl={4} md={4} xs={4}>
                                                        <span className='text-success' style={{marginLeft: "3.5rem"}}>
                                                          {/* ผู้อำนวยการ :  */}
                                                          {userOrg?.find(x => x.org_id === i.org_id)?.position_id === 7 ? "หัวหน้ากลุ่ม : " : "" }
                                                          {userOrg?.find(x => x.org_id === i.org_id)?.user_name}
                                                        </span>
                                                      </Col>
                                                  </div>
                                              </ListGroupItem>
                                          : ""
                                      )}
                                      </Collapse>
                                  </Fragment>
                              : ""
                          )}
                    </Collapse>
                  </Fragment>
                </ListGroup>
                <Modal isOpen={modalAddOrEdit} centered toggle={toggles} size="lg">
                    <ModalHeader>
                        {modalState === "ADD" ? "เพิ่มข้อมูล" : modalState === "EDIT" && "แก้ไขข้อมูล"}ผังองค์กร
                        <div className="position-absolute top-0 end-0">
                            <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggles}></i>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                      {org_structure?.map((item, idx) => {
                        return(
                          <FormGroup row key={idx}>
                            <Label className="text-end" xxl={4} xs={4}> {item.label} </Label>
                            <Col className={item.checkbox && 'd-flex align-items-center'}>
                              {!item.org_chart ? 
                                <Fragment>
                                  <Input invalid={item.checkbox ? false : !dataInput[item.feild] && item.invalidCheck} value={dataInput[item.feild]} defaultChecked={dataInput?.active} type={item.type} name={item.feild}
                                      onChange={ async (e) => { 
                                          handleInputChange(e, item.feild, item.validated, item.checkbox); 
                                      }}
                                  ></Input>
                                  {(!dataInput[item.feild] && item.invalidCheck) && <FormFeedback>{item.invalidFeedback}</FormFeedback>}
                                </Fragment>
                              : orgOptions ? <Select
                                  className="basic-single"
                                  classNamePrefix="สำนัก/กอง"
                                  defaultValue= {orgOptions.find(option => option.value === (dataInput?.parent_id ?? 1))}
                                  isSearchable={true}
                                  placeholder='สำนัก/กอง...'
                                  options={orgOptions}
                                  required={true}
                                  onChange={async e => handleInputChange(e, item.feild, item.validated)}
                                /> : <h5><i class="fa-duotone fa-spinner-third fa-spin"></i></h5>
                              }
                            </Col>
                          </FormGroup>
                        )
                      })}
                        {/* {modalState === "EDIT" && 
                          <FormGroup row>
                            <Label className="text-end" xxl={4} xs={4}> ต้องการที่จะลบข้อมูล </Label>
                            <Col>
                              <Button className='mt-1' color='danger' onClick={() => {setConfirmModal(true); setConfirmModalState("DELETE") }}><i className="fa-solid fa-trash"></i></Button>
                            </Col>
                          </FormGroup>
                        } */}
                    </ModalBody>
                    <ModalFooter>
                        <Button color={modalState === "ADD" ? "success" : modalState === "EDIT" ? "warning" : ""} onClick={() => {setConfirmModal(true); setConfirmModalState("RECORD");}} >
                            {modalState === "ADD" ? "บันทึก" : modalState === "EDIT" ? "บันทึกการแก้ไข" : "" }
                        </Button>
                    </ModalFooter>
                </Modal>
                <ConfirmModal
                    modal = {confirmModal}
                    modalSize = "md"
                    modalHeaderContent ={confirmModalState === "DELETE" ? "คุณต้องการที่จะลบ ใช่หรือไม่?" : confirmModalState === "RECORD" ? "คุณต้องการที่จะบันทึก ใช่หรือไม่?" : ""}
                    onClickConfirmBtn={() => {
                    if (confirmModalState === "DELETE") {
                        positionNoDeleteDataTable();
                    } else if (confirmModalState === "RECORD") {
                        fetchToDB()
                    }
                    setConfirmModal(false)
                    }}
                    onClickCancelBtn={() => {
                    setConfirmModal(false)
                    }}
                />
            </FadeIn>
          )}
        </ModalBody>
      </Modal>
    </Fragment>
  )
}

export default OrganizationChart